import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import WhyChooseUs from '../components/WhyChooseUs';
import Services from '../components/Services';
import Doctors from '../components/Doctors';
import Gallery from '../components/Gallery';
import Testimonials from '../components/Testimonials';
import Stats from '../components/Stats';
import Resources from '../components/Resources';
import FAQ from '../components/FAQ';
import CTABanner from '../components/CTABanner';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <>
      <Navbar />
      <Hero />
      <WhyChooseUs />
      <Services />
      <Doctors />
      <Gallery />
      <Resources />
      <Testimonials />
      <Stats />
      <FAQ />
      <CTABanner />
      <Footer />
    </>
  );
};

export default Home;
